import { useSubmitEnrollmentJointDeclineData } from '@egw/api'
import { Button } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { EnrollmentHYCSLayout } from '@egw/layouts'
import { Logger } from '@egw/logger'
import { type FC } from 'react'
import { useNavigate } from 'react-router'
import { enrollmentCookieService } from '@egw/enrollment-cookie'
import { riskService } from '@egw/risk-service'
import { PageHeader } from '../../../components'
const log = new Logger('Enrollment - Generic - Decline')

export enum DeclineExperiment {
  Joint = 'joint',
}

export interface DeclinePageProps {
  experiment?: DeclineExperiment
}

export const DeclinePage: FC<DeclinePageProps> = ({ experiment }) => {
  const { t } = useTranslation('features-enrollment')

  const navigate = useNavigate()

  const { mutate, isLoading } = useSubmitEnrollmentJointDeclineData({
    onSuccess: (res) => {
      if (res?.activePerson?.path) {
        log.debug('Decline Page - Joint Enrollment - Successfully ReInitiated Application', res)
        void navigate(res.activePerson.path)
      } else {
        log.debug('Decline Page - Navigating to Enrollment Home')
        // New application should be initiated at this point
        void navigate(WEALTH_ROUTES.ENROLLMENT.path)
      }
    },
  })

  const onSubmit = async (): Promise<void> => {
    if (experiment === DeclineExperiment.Joint) {
      log.debug('Decline Page - Joint Enrollment - Initiating Application')
      // Reset enrollment session before initiating application
      await enrollmentCookieService.resetSession()
      await riskService.updateFlow('enrollment')
      void mutate({ initiateApplication: true })
    } else {
      log.debug('Decline Page - Navigating to Enrollment Home')
      void navigate(WEALTH_ROUTES.ENROLLMENT.path)
    }
  }

  return (
    <EnrollmentHYCSLayout title={t('generic.decline.page_title')}>
      <div className="egw-container-enroll-hycs h-full flex flex-col relative md:justify-center justify-start items-start">
        <PageHeader title={t('generic.decline.title')} />
        <div className="flex flex-col gap-md">
          <p className="typo-primary-base text-text-body">{t('generic.decline.description_1')}</p>
          <p className="typo-primary-base text-text-body">{t('generic.decline.description_2')}</p>
        </div>
        <div className="flex-1 md:hidden" />

        <Button
          isLoading={isLoading}
          type="submit"
          className="w-full md:w-min mt-xl"
          onClick={() => void onSubmit()}
          testId="primaryAction_button"
        >
          {t('generic.decline.cta')}
        </Button>
      </div>
    </EnrollmentHYCSLayout>
  )
}
